document.addEventListener('DOMContentLoaded', function() {
  $(".sk-accordion__toggle").on("click", function () {
    $(this).next().toggleClass("show");
    $(this).next().stop().slideToggle(100);

    if ($(this).next().hasClass("show")) {
      $(this).find(".icon-caret").toggleClass("show");
    } else {
      $(this).find(".icon-caret").removeClass("show");
    }
  });
});